import { CaptureEmailAddress, EmailPreferencesIdQuery } from '../gql/user';

export const captureEmailAddressInEmailPrefs = async (
  emailAddress,
  acquisitionChannel,
  isOptedIn,
  firstName,
  userId,
) => {
  const anonymousId = window?.analytics?.user?.().anonymousId?.()
    ? { anonymousId: analytics.user().anonymousId() }
    : {};

  const userIdParam = userId ? { userId } : {};

  const firstNameParam = firstName ? { firstName } : {};
  const gql = window.UNSAFE_DO_NOT_USE_EVER_GQL_CLIENT;
  const result = await gql.mutate({
    mutation: CaptureEmailAddress,
    errorPolicy: 'all',
    variables: {
      emailAddress,
      acquisitionChannel,
      isOptedIn,
      ...firstNameParam,
      ...anonymousId,
      ...userIdParam,
    },
  });
  const { data, errors } = result;

  if (errors) {
    // eslint-disable-next-line no-console
    return console.error(errors);
  }

  return data.captureEmailAddress;
};

export const retrieveEmailId = async (emailAddress) => {
  const gql = window.UNSAFE_DO_NOT_USE_EVER_GQL_CLIENT;
  const { data, errors } = gql.query({
    query: EmailPreferencesIdQuery,
    variables: { emailAddress },
  });

  if (errors) {
    // eslint-disable-next-line no-console
    return console.error(errors);
  }

  return data?.emailPreferences?.id;
};
